import { render } from "./ChartColetaMensalPage.vue?vue&type=template&id=3528d1da&scoped=true"
import script from "./ChartColetaMensalPage.vue?vue&type=script&lang=js"
export * from "./ChartColetaMensalPage.vue?vue&type=script&lang=js"

import "./ChartColetaMensalPage.vue?vue&type=style&index=0&id=3528d1da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3528d1da"]])

export default __exports__